export default function isSharedFolder(folderId) {
    /* TODO: 1604 add sharedFolders into react */
    return false;
}
//# sourceMappingURL=isSharedFolder.js.map